import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Heading, IconOnePass as BaseIconOnePass, LinkButton, Text } from "@catchoftheday/cg-components";
import { MigrationNudgeContentZone } from "../../layouts/MigrationNudgeLayout/MigrationNudgeLayout";
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconOnePass = function IconOnePass(props) {
  return ___EmotionJSX(BaseIconOnePass, _extends({
    "aria-label": "OnePass",
    color: "onePass.primary",
    height: "1em",
    width: "auto",
    mt: {
      xs: -1,
      md: -2
    }
  }, props));
};

export var Content = function Content(_ref) {
  var CTAUrl = _ref.CTAUrl,
      onCTAClick = _ref.onCTAClick;
  return ___EmotionJSX(MigrationNudgeContentZone, null, ___EmotionJSX(Heading.h3, {
    fontWeight: "bold",
    fontSize: {
      xs: "base",
      md: "2xl"
    },
    mb: 4,
    mt: 0
  }, "Transfer your", ___EmotionJSX(IconOnePass, {
    mx: 1
  }), "subscription"), ___EmotionJSX(Text, {
    fontSize: {
      xs: "sm",
      md: "lg"
    },
    fontWeight: "medium",
    mb: 4,
    mt: 0
  }, "OnePass has a new home. Transfer your subscription to activate your new benefits."), ___EmotionJSX(LinkButton, {
    variant: "onePassPrimary",
    fontSize: "sm",
    fontWeight: "semibold",
    onClick: onCTAClick,
    width: "auto",
    href: CTAUrl
  }, "Show me how"));
};